<template>
  <div class="TournamentCard card hover">
    <div v-on:click="openTournament" class="tc">
      <div class="TournamentName">{{ tournament.name }}</div>
      <div class="numOfTeams">Number of teams: {{ tournament.teams.length }}</div>
      <div class="status">{{tournament.status.status}}</div>
    </div>
    <div class="remove red-glow" v-on:click="removeTournament"></div>
  </div>
</template>


<script>

export default {
  name: 'TournamentCard',
  props: ["tournament"],
  computed: {
        teamName(){
      return this.$store.getters.team(this.tournament.status.winner).name
    }
  },
  methods: {
    openTournament(){
      this.$router.push('/tournament/' + this.tournament.id);
    },
    removeTournament(){
      this.$store.dispatch('removeTournament',this.tournament.id);
    },
    openBracket(){
      this.$router.push('/tournament/' + this.tournament.id + '/bracket');
    }
  }

}
</script>


<style scoped>
.TournamentCard{
  display: grid;
  grid-template-columns: auto 30px;
  grid-template-areas:
    'inner    remove';
  height: 100px;
}

.tc{
  grid-area: inner;
  display: grid;
  grid-template-areas:
    'TournamentName   TournamentName'
    'numOfTeams       numOfTeams'
    'status           status';
  margin: 10px;
}

.TournamentName{
  grid-area: TournamentName;
  font-size: 25px;
}

.numOfTeams{
  grid-area: numOfTeams;
  font-size: 17px;
}

.status{
  grid-area: status;
  font-size: 15px;
}

.teams{
  grid-area: teams;
  text-align: right;
  background-image: url(../assets/editTournament.png);
  width: 30px;
  height: 33px;
  background-size: 30px 33px
}
.teams:hover{
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);

  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
}

.bracket{
  grid-area: bracket;
  text-align: right;
  background-image: url(../assets/bracket.png);
  width: 30px;
  height: 33px;
  background-size: 30px 33px;
}
.bracket:hover{
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);

  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
}

.remove{
  grid-area: remove;
  text-align: right;
  background-image: url(../assets/removePlayer.png);
  width: 30px;
  height: 100px;
  background-size: 30px 100px;
}
.remove:hover{
  /*transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);

  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.24);*/
}

@media (max-width: 600px) {
  .TournamentCard{
    padding: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TournamentCard.vue